import { Component, Input, OnInit, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { BaseUser } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService, SupplierExtendedData } from '../../../services/api.services';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OperatorFront } from '../../../models/api.models';
import { HeaderSharedData } from '../header.shared.data';


@Component({
  selector: 'app-opciones-perfil',
  templateUrl: './opciones-perfil.component.html',
  styleUrls: ['./opciones-perfil.component.scss'],
})

export class OpcionesPerfilComponent implements OnInit, OnDestroy {

  @Input() operarios: OperatorFront[];
  @Input() supplierUser: BaseUser;
  @Input() sharedData: HeaderSharedData;

  popPadre: HTMLIonPopoverElement;
  showMultiOperatorFilter = true;
  operatorId: number;
  el: ElementRef;
  private operatorSelectSubscription: Subscription;

  constructor(private router: Router,
              private popoverCtrl: PopoverController,
              private portalProveedorService: PortalProveedorService) {
  }

  async ngOnInit() {
    this.popPadre = await this.popoverCtrl.getTop();
    this.portalProveedorService.getSupplierDataCached().subscribe((supplierExtendedData: SupplierExtendedData) => {
      if (supplierExtendedData.supplier.house_supplier_view_permissions.must_select_operator) {
        this.showMultiOperatorFilter = false;
      } else {
        this.showMultiOperatorFilter = true;
      }

    });
    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    this.selectOperator(operatorIdSelected);
    this.operatorSelectSubscription = this.portalProveedorService.onChangeOperatorSelected(this.selectOperator);
  }

  operatorSelected(event) {
    if (event.detail.value === -2) {
      this.portalProveedorService.setOperatorSel(null);
    } else {
      this.portalProveedorService.setOperatorSel(event.detail.value);
    }
    this.portalProveedorService.selectOperatorEvent.emit(this.portalProveedorService.getOperatorSel());
    this.popPadre.dismiss();
  }

  openConfig() {
    this.router.navigate(['main', 'configuracion']);
    this.popoverCtrl.dismiss();
  }

  cerrarSesion() {
    this.portalProveedorService.cerrarSesion();
    this.popoverCtrl.dismiss();
  }

  ngOnDestroy(): void {
    if (this.operatorSelectSubscription) {
      this.operatorSelectSubscription.unsubscribe();
    }
  }

  private selectOperator =  (id: number) => {
    if (id) {
      this.operatorId = id;
    } else {
      this.operatorId = -2;
    }
  }
}
